// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__ZuodK","label":"CategoryService_label__2r_XG","location":"CategoryService_location__g5Eq8"};